import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { screenXsMax } from '@spotify-internal/encore-web';

export const GlobalWaveformStyles = css`
  .wave-wrapper {
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* Internet Explorer 10+ */
    &::-webkit-scrollbar {
      /* WebKit */
      width: 0;
      height: 0;
    }
  }

  .wave-segment {
    border-radius: 10px;
  }

  // For SAI Wavform
  // We want to keep the regions visible no matter what the waveform size
  .wavesurfer-region {
    z-index: 3 !important;
    width: 3px !important;
  }

  .wave-segment[data-segment-deleted='true'] {
    background-color: rgba(0, 0, 0, 0.3);
  }
  .wave-segment::before,
  .wave-segment::after {
    position: absolute;
    z-index: -1;
    display: block;
    width: 100%;
    height: 20px;
    border-radius: 10px;
    background: rgb(80, 155, 245) none repeat scroll 0% 0%;
    content: '';
  }
  .wave-segment::before {
    top: 0;
  }
  .wave-segment::after {
    bottom: 0;
  }
  .wave-segment[data-segment-deleted='true']::before,
  .wave-segment[data-segment-deleted='true']::after {
    background: rgb(57, 107, 171);
  }
  .wave-handle.wave-handle-end {
    width: 0px;
  }
  .wave-handle.wave-handle-start::before,
  .wave-handle.wave-handle-start::after,
  .wave-handle.wave-handle-end::before,
  .wave-handle.wave-handle-end::after {
    position: absolute;
    left: -7px;
    z-index: -2;
    display: block;
    width: 10px;
    height: 10px;
    background: #f7f7f7;
    content: '';
  }
  .wave-handle.wave-handle-start::before,
  .wave-handle.wave-handle-start::after {
    left: 0;
  }
  .wave-handle.wave-handle-end::before,
  .wave-handle.wave-handle-end::after {
    left: -10px;
  }
  .wave-handle.wave-handle-end::before {
    top: -10px;
  }
  .wave-handle.wave-handle-end::after {
    bottom: -11px;
  }
  .wave-handle.wave-handle-start::before {
    top: -10px;
  }
  .wave-handle.wave-handle-start::after {
    bottom: -11px;
  }
  .wave-handle-remove {
    position: absolute;
    bottom: 7px;
    left: -7px;
    padding: 0;
    line-height: 0;
  }
  .wave-handle-remove:first-of-type {
    display: none;
  }
  .wave-minimized {
    position: absolute;
    bottom: 6px;
    left: -9px;
    z-index: 6;
    display: none;
    width: 20px;
    height: 20px;
    padding: 0;
    border-radius: 50%;
    color: white;
    font-size: 1.4rem;
    line-height: 0;
    background-color: #5000b9;
  }
  .wave-handle-delete {
    position: absolute;
    top: 8px;
    right: 16px;
    padding: 0;
    & span {
      position: absolute;
      bottom: -14px;
      left: -10px;
      width: 42px;
      color: #fff;
      font-size: 1.2rem;
      white-space: nowrap;
      text-align: center;
      opacity: 0;
      transition: opacity 0.15s ease-in-out;
    }
    &:hover span {
      opacity: 1;
    }
  }
  .wave-minimap {
    border-radius: 4px;
  }
  .wave-progress,
  .wave-minimap-progress {
    z-index: 30 !important;
    overflow: visible !important;
    &::before {
      position: absolute;
      top: 0px;
      right: -9px;
      z-index: 3;
      border-top: 12px solid #000;
      border-right: 8px solid transparent;
      border-left: 8px solid transparent;
      content: '';
    }
  }
  .wave-progress-playhead {
    position: absolute;
    top: 0px;
    right: -20px;
    z-index: 30;
    border-radius: 10px;
    color: white;
    font-size: 1.2rem;
    background: black;
  }
  .wave-handle-input {
    position: absolute;
    top: 7px;
    left: 16px;
    width: 60%;
    max-width: 170px;
    height: 24px;
    border: none;
    color: white;
    font-size: 1.6rem;
    white-space: nowrap;
    background: transparent;
    resize: none;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* Internet Explorer 10+ */
    &::-webkit-scrollbar {
      /* WebKit */
      width: 0;
      height: 0;
    }
    &:focus {
      width: 80%;
      max-width: 250px;
      height: 40%;
      border: 1px solid white;
      border-radius: 10px;
      white-space: unset;
      background: linear-gradient(
          0deg,
          rgba(255, 255, 255, 0.1),
          rgba(255, 255, 255, 0.1)
        ),
        #509bf5;
      box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    }
  }
`;

export const WaveformControlsContainer = styled.div`
  display: flex;
  gap: 16px;
  align-items: start;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
  text-align: left;

  @media (max-width: ${screenXsMax}) {
    flex-direction: column;
    align-items: center;
  }
`;

export const WaveformLeftControlsContainer = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  margin-top: 20px;
  text-align: left;
`;

export const Divider = styled.div`
  position: absolute;
  right: -56px;
  left: -56px;
  height: 1px;
  margin-top: 24px;
  background-color: #dadada;
`;
